export default __webpack_public_path__ + "static/media/office-2-bhs.348d70d2.mp4";